import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class BookingTimerService {
  //   Timer Logic
  private readonly countdownDuration = 15 * 60; // 15 minutes in seconds can be changed 1 for testing.
  private timerSubscription: Subscription;
  private remainingTime = this.countdownDuration;
  private hasWarned = false;
  private warnSubject = new BehaviorSubject<boolean>(false);
  warn$ = this.warnSubject.asObservable();
  private timerStartTime;

  private timerSubject = new BehaviorSubject<number>(this.remainingTime);
  timer$ = this.timerSubject.asObservable();

  constructor(private router: Router) { }

  startTimer() {
    if (this.timerSubscription && !this.timerSubscription.closed) {
      return;
    }

    // Only set/reset remaining time if this is the first time it's being run
    if (this.remainingTime <= 0 || this.remainingTime === this.countdownDuration) {
      this.remainingTime = this.countdownDuration;
      this.timerSubject.next(this.remainingTime);
      this.hasWarned = false;
      this.warnSubject.next(false);
      this.timerStartTime = moment()
    }

    this.timerSubscription = interval(1000).subscribe(() => {
      const duration = moment.duration(moment().diff(this.timerStartTime));
      const seconds = duration.asSeconds();
      this.remainingTime = this.countdownDuration - seconds;

      this.timerSubject.next(this.remainingTime);
      // 🔸 Trigger 1-minute warning
      if (this.remainingTime < 60 && !this.hasWarned) {
        this.hasWarned = true;
        this.warnSubject.next(true); // Fire the warning observable
      }

      if (this.remainingTime <= 0) {
        this.stopTimer();
        this.router.navigate(['/sessionExpired']);
      }
    });
  }



  resetTimer() {
    this.stopTimer();
    this.remainingTime = this.countdownDuration;
    this.timerSubject.next(this.remainingTime);
    this.hasWarned = false;
    this.warnSubject.next(false);
  }

  stopTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  getFormattedTime() {
    const minutes = Math.floor(this.remainingTime / 60);
    const seconds = Math.round(this.remainingTime % 60);
    return { minutes, seconds };
  }
}
